function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#282828;}\n\t.st1{fill:#FFFFFF;}\n");

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  className: "st0",
  cx: 50.2,
  cy: 50.2,
  r: 50.2
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M50.2,28.3v7c0.1,1.1,1.1,2,2.3,1.9c0.5,0,0.9-0.2,1.2-0.6l10.6-10.5c0.7-0.5,0.9-1.6,0.3-2.3 c-0.1-0.1-0.2-0.2-0.3-0.3L53.7,12.9c-1.8-1.8-3.5-0.9-3.5,0.9v7c-16.8,0-30.6,13.5-30.8,30.4c0,3.8,0.8,7.5,2.2,11 c1.3,2.6,4.4,3.5,6.2,1.3c1.1-1,1.5-2.6,0.9-4c-1.1-2.6-1.6-5.5-1.3-8.4C27.4,38.5,37.6,28.4,50.2,28.3z M72.2,38.9 c-1.1,1-1.5,2.6-0.9,4c1.1,2.6,1.5,5.5,1.3,8.4C72.7,63.7,62.6,74,50,74.1h-0.3v-6.6c-0.1-1.1-1.1-2-2.3-1.9c-0.5,0-0.9,0.2-1.2,0.6 L35.7,76.7c-0.7,0.5-0.9,1.6-0.3,2.3c0.1,0.1,0.2,0.2,0.3,0.3l10.6,10.6c0.7,0.8,2,0.9,2.8,0.2c0.4-0.4,0.7-0.9,0.7-1.5v-7 c16.8,0,30.4-13.6,30.4-30.4c-0.1-3.8-0.8-7.5-2.2-11c-0.4-1.7-2.1-2.9-3.8-2.5C73.3,37.8,72.7,38.2,72.2,38.9L72.2,38.9z"
});

const SvgLooper = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  id: "Ebene_1",
  x: "0px",
  y: "0px",
  viewBox: "0 0 100.3 100.3",
  style: {
    enableBackground: "new 0 0 100.3 100.3"
  },
  xmlSpace: "preserve",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2, _ref3);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLooper, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/looper.d173b8e5.svg";
export { ForwardRef as ReactComponent };